import { render } from "./JsonManager.vue?vue&type=template&id=6c33aa1c&scoped=true&ts=true"
import script from "./JsonManager.vue?vue&type=script&lang=ts"
export * from "./JsonManager.vue?vue&type=script&lang=ts"

import "./JsonManager.vue?vue&type=style&index=0&id=6c33aa1c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c33aa1c"]])

export default __exports__